import React, { useEffect, useState } from 'react'
import { useSpring, animated } from '@react-spring/web'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

const MyFreebirdOpacityScreen = ({
  user,
  forbiddenLinkClicked,
  newMemberMessage,
}) => {
  const [showScreen, setShowScreen] = useState(false)

  useEffect(() => {
    if (forbiddenLinkClicked[0] === true) {
      setShowScreen(true)
    } else if (newMemberMessage !== '') {
      if (
        //(newMemberMessage === 'nf' && cookies.get('nfv') !== 'y') ||
        (newMemberMessage === 'mu' && cookies.get('muv') !== 'y') ||
        newMemberMessage === 'emf'
      ) {
        setShowScreen(true)
      } else {
        setShowScreen(false)
      }
    } else {
      setShowScreen(false)
    }
  }, [forbiddenLinkClicked, newMemberMessage])

  const fadeStyles = useSpring({
    delay: 0,
    config: { duration: 300 },
    from: { opacity: 0 },
    to: {
      opacity: showScreen ? 0.85 : 0,
    },
  })

  return (
    <animated.div
      style={{
        backgroundColor: '#fff',
        position: 'fixed',
        pointerEvents: 'none',
        top: 0,
        left: 0,
        zIndex: 1000,
        width: '100%',
        height: '100vh',
        ...fadeStyles,
      }}
    />
  )
}

export default withRouter(withAuth(MyFreebirdOpacityScreen))
